var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconScreenRecorderEditingPreviewDownload = function SvgIconScreenRecorderEditingPreviewDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.751 11.168a1.56 1.56 0 0 0-2.2 0l-3.494 3.493V2.055a1.559 1.559 0 0 0-3.115 0v12.522l-3.493-3.494a1.56 1.56 0 0 0-2.201 0 1.56 1.56 0 0 0 0 2.202l6.19 6.196c.304.303.701.457 1.104.457a1.57 1.57 0 0 0 1.103-.457l6.111-6.112a1.555 1.555 0 0 0-.005-2.201M23.608 22.578H1.393c-.765 0-1.381.616-1.381 1.381 0 .766.616 1.382 1.381 1.382h22.215a1.381 1.381 0 0 0 0-2.763"
  })));
};
export default SvgIconScreenRecorderEditingPreviewDownload;